import script from "./GeneralInformationView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeneralInformationView.vue?vue&type=script&setup=true&lang=ts"

import "./GeneralInformationView.vue?vue&type=style&index=0&id=3c5fd07c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c5fd07c"]])

export default __exports__